// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14jA2","inner":"Footer_inner__3Qmyv","nextIcon":"Footer_nextIcon__1hFO5","innerLeft":"Footer_innerLeft__3RGjI"};